import React from "react";
import PropTypes from "prop-types";

// styles
import FormErrorStyled from "./FormError.styled";

const FormError = props => {
    // destructuring props
    const { title, text } = props;
    return (
        <FormErrorStyled>
            <p>
                {title}
            </p>
            <p>{text}</p>
        </FormErrorStyled>
    );
};

export default FormError;

// props validation
FormError.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};
